export function StatCard({ label, value, sub, accent = "", testId, Icon }) {
  return (
    <div className="bg-card border border-border rounded-md p-5 animate-fade-up" data-testid={testId}>
      <div className="flex items-start justify-between">
        <p className="text-xs uppercase tracking-wider text-muted-foreground font-medium">{label}</p>
        {Icon && <Icon className={`h-4 w-4 ${accent || "text-muted-foreground"}`} />}
      </div>
      <p className={`mt-3 font-mono text-2xl font-semibold tracking-tight ${accent}`}>{value}</p>
      {sub && <p className="mt-1 text-xs text-muted-foreground">{sub}</p>}
    </div>
  );
}
